import { render, staticRenderFns } from "./VideoSeriesHost.vue?vue&type=template&id=1eda1c9d&scoped=true&"
import script from "./VideoSeriesHost.vue?vue&type=script&lang=js&"
export * from "./VideoSeriesHost.vue?vue&type=script&lang=js&"
import style0 from "./VideoSeriesHost.vue?vue&type=style&index=0&id=1eda1c9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda1c9d",
  null
  
)

export default component.exports